export const HEADER_KEYS = {
  PROFILE: 'header_profile',
  CHANGE_PASSWORD: 'header_change_password',
  LOGOUT: 'header_logout',
  TITTLE: 'header_tittle',
  SUBTITLE: 'header_sub_tittle',
  NOTIFICATION: 'header_notification',
  PROFILE_DESCRIPTION: 'header_profile_desc',
  CHANGE_PASSWORD_DESCRIPTION: 'header_change_password_desc',
  NOTIFICATION_DESCRIPTION: 'header_notification_desc',
}

export const MODAL_KEYS = {
  OTP_MESSAGE: 'modal_otp_message',
  LOGOUT_MESSAGE: 'modal_logout_message',
  IMAGE_DELETE_MESSAGE: 'modal_delete_image_message',
  ENTER_CODE: 'modal_enter_code',
  CANCEL_MESSAGE: 'modal_cancel_message',
}

export const PROFILE_KEYS = {
  IMAGE_UPLOAD: 'profile_image_upload',
  USER_NAME: 'profile_user_name',
  COMPANY_NAME: 'profile_company_name',
  COMPANY_BRANCH: 'profile_company_branch',
  DOB: 'profile_dob',
  MOBILE_NO: 'profile_mobile_no',
  GENDER: 'profile_gender',
  EMAIL: 'profile_email',
  ADDRESS: 'profile_address',
  HEADER: 'profile_header',
}

export const CHANGE_PASSWORD_KEYS = {
  CHANGE_PASSWORD: 'change_password',
  CURRENT_PASSWORD: 'change_password_current_password',
  NEW_PASSWORD: 'change_password_new_password',
  CONFIRM_NEW_PASSWORD: 'change_password_confirm_new_password',
  PASSWORD_CRITERIA: 'change_password_criteria',
}

export const BUTTON_KEYS = {
  SUBMIT: 'submit_button',
  CANCEL: 'cancel_button',
  OK: 'ok_button',
  YES: 'yes_button',
  NO: 'no_button',
  DONE: 'done_button',
  EDIT_BANEFICIARY: 'edit_beneficiary_button',
  DELETE_BENEFICIARY: 'delete_beneficiary_button',
  MODIFY_BENEFICIARY: 'modify_beneficiary_button',
  MAKE_PAYMENT: 'make_payment_button',
  BACK: 'back_button',
  CONFIRM: 'confirm_button',
  CLOSE: 'close_button',
  DOWNLOAD: 'download_button',
  CALCULATE: 'calculate_button',
  CLEAR: 'clear_button',
  LETSSTART: 'lets_start_button',
  LOGIN: 'login_button',
  RESET: 'reset_button',
  SEARCH: 'search_button',
  ADD: 'add_button',
  DELETE: 'delete_button',
  CREATE: 'create_button',
  ACCEPT: 'accept_button',
  TEMPLATE: 'template_button',
}

export const DASHBOARD_HEADER_KEYS = {
  HI: 'dashboard_header_hi',
  LAST_LOGIN: 'dashboard_header_last_login',
  AUTO_AUTHORIZER: 'dashboard_header_auto_authorizer',
  AUTHORIZER: 'dashboard_header_authorizer',
  INITIATOR: 'dashboard_header_initiator',
  VERIFIER: 'dashboard_header_verifier',
  VIEWER: 'dashboard_header_viewer',
}

export const SIDE_NAV_KEYS = {
  DASHBOARD: 'side_nav_dashboard',
  PORTFOLIO: 'side_nav_portfolio',
  TRANSFERS: 'side_nav_transfers',
  ACCOUNTS: 'side_nav_accounts',
  PAYMENTS: 'side_nav_payments',
  REQUESTS: 'side_nav_requests',
  EXCHANGE_RATES: 'side_nav_exchange_rates',
  OTHER_SERVICES: 'side_nav_other_services',
  APPROVALS: 'side_nav_approvals',
  HISTORY: 'side_nav_history',
  DASHBOARD_DESCRIPTION: 'side_nav_dashboard_desc',
  PORTFOLIO_DESCRIPTION: 'side_nav_portfolio_desc',
  EXCHANGE_RATES_DESCRIPTION: 'side_nav_exchange_rates_desc',
  OTHER_SERVICES_DESCRIPTION: 'side_nav_other_services_desc',
}

export const ACCOUNTS_MENU_KEYS = {
  STATEMENT: 'accounts_menu_statement',
  PAYMENTS: 'accounts_menu_payments',
  QUICK_PAY: 'accounts_menu_quick_pay',
  REQUESTS: 'accounts_menu_requests',
  BENEFICIARY_TRANSFERS: 'accounts_menu_beneficiary_transfers',
  LOANS: 'accounts_menu_loans',
  DEPOSITS: 'accounts_menu_deposits',
  SI: 'accounts_menu_si',
  SET_ACCOUNT_NAME: 'accounts_menu_set_account_name',
  SEND_TO_WALLET: 'accounts_menu_send_to_wallet',
  STATEMENT_DESCRIPTION: 'accounts_menu_statement_desc',
  PAYMENTS_DESCRIPTION: 'accounts_menu_payments_desc',
  REQUESTS_DESCRIPTION: 'accounts_menu_requests_desc',
  BENEFICIARY_TRANSFERS_DESCRIPTION: 'accounts_menu_beneficiary_transfers_desc',
  LOANS_DESCRIPTION: 'accounts_menu_loans_desc',
  DEPOSITS_DESCRIPTION: 'accounts_menu_deposits_desc',
  SI_DESCRIPTION: 'accounts_menu_si_desc',
  SET_ACCOUNT_NAME_DESCRIPTION: 'accounts_menu_set_account_name_desc',
  CARD_LESS_CASH: 'account_cardless_cash',
  CARD_LESS_CASH_DESCRIPTION: 'account_menu_cardless_cash_desc',
  QUICK_PAY_DESCRIPTION: 'accounts_menu_quick_pay_desc',
  SEND_TO_WALLET_DESCRIPTION: 'accounts_menu_send_to_wallet_desc',
}

export const TRANSFERS_MENU_KEYS = {
  ADD_BENEFICIARY: 'transfers_menu_add_beneficiary',
  BENEFICIARY_TRANSFERS: 'transfers_menu_beneficiary_transfers',
  VIEW_BENEFICIARY: 'transfers_menu_view_beneficiary',
  SALARY_UPLOAD: 'transfers_menu_salary_upload',
  BULK_TRANSFER: 'transfers_menu_bulk_transfer',
  QUICK_PAY: 'transfers_menu_quick_pay',
  DOWNLOAD_CENTER: 'transfers_menu_download_center',
  ADD_BENEFICIARY_DESCRIPTION: 'transfers_menu_add_beneficiary_desc',
  BENEFICIARY_TRANSFERS_DESCRIPTION: 'transfers_menu_beneficiary_transfers_desc',
  VIEW_BENEFICIARY_DESCRIPTION: 'transfers_menu_view_beneficiary_desc',
  SALARY_UPLOAD_DESCRIPTION: 'transfers_menu_salary_upload_desc',
  BULK_TRANSFER_DESCRIPTION: 'transfers_menu_bulk_transfer_desc',
  QUICK_PAY_DESCRIPTION: 'transfers_menu_quick_pay_desc',
  DOWNLOAD_CENTER_DESCRIPTION: 'transfers_menu_download_center_desc',
  VIEW_SCHEDULED_TRANSFERS_DESCRIPTION: 'transfers_menu_view_scheduled_transfers_desc',
}

export const PAYMENTS_MENU_KEYS = {
  ADD_BILLER: 'payments_menu_add_biller',
  PAY_BILL: 'payments_menu_pay_bill',
  VIEW_BILLER: 'payments_menu_view_biller',
  SERVICES: 'payments_menu_services',
  BUY_DATA: 'payments_menu_buy_data',
  BUY_AIRTIME: 'payments_menu_buy_airtime',
  ADD_BILLER_DESCRIPTION: 'payments_menu_add_biller_desc',
  PAY_BILL_DESCRIPTION: 'payments_menu_pay_bill_desc',
  VIEW_BILLER_DESCRIPTION: 'payments_menu_view_biller_desc',
  SERVICES_DESCRIPTION: 'payments_menu_services_desc',
  BUY_DATA_DESCRIPTION: 'payments_menu_buy_data_desc',
  BUY_AIRTIME_DESCRIPTION: 'payments_menu_buy_airtime_desc',
  VIEW_SCHEDULED_PAYMENTS_DESCRIPTION: 'payments_menu_view_scheduled_payments_desc',
}

export const REQUESTS_MENU_KEYS = {
  CHEQUE: 'requests_menu_cheque',
  SI: 'requests_menu_si',
  DEBIT_CARD: 'requests_menu_debit_card',
  CHEQUE_DESCRIPTION: 'requests_menu_cheque_desc',
  SI_DESCRIPTION: 'requests_menu_si_desc',
  DEBIT_CARD_DESCRIPTION: 'requests_menu_debit_card_desc',
}

export const QUICK_PAY_MENU_KEYS = {
  INSTANT_TRANSFER: 'quick_pay_instant_transfer',
  INSTANT_TRANSFER_DESCRIPTION: 'quick_pay_instant_transfer_desc',
}

export const OTHER_SRVICES_MENU_KEYS = {
  DOWNLOAD_CENTER: 'other_services_menu_download_center',
  SUPPORT_CENTER: 'other_services_menu_support_center',
  TERMS_CONDITIONS: 'other_services_menu_terms_conditions',
  DOWNLOAD_CENTER_DESC: 'other_services_menu_download_center_desc',
  SUPPORT_CENTER_DESC: 'other_services_menu_support_center_desc',
  TERMS_CONDITIONS_DESC: 'other_services_menu_terms_conditions_desc',
}

export const PORTFOLIO_KEYS = {
  ASSETS: 'portfolio_assets',
  LIABILITIES: 'portfolio_liability',
  TD_ACCOUNT: 'portfolio_td_account',
  SAVINGS_ACCOUNT: 'portfolio_savings_account',
  CURRENT_ACCOUNT: 'portfolio_current_account',
  LOAN_ACCOUNT: 'portfolio_loan_account',
  NO_ACCOUNTS: 'portfolio_no_accounts',
}

export const ACCOUNT_CARD_KEYS = {
  CLIENT_NAME: 'account_card_client_name',
  AVAILABLE_BALANCE: 'account_card_available_balance',
  ACCOUNT_CARD_DESCRIPTION: 'account_card_description',
  SOURCE_ACCOUNT: 'account_card_source_account',
  CURRENT_BALANCE: 'account_card_current_balance',
  CURRENT_ACCOUNT: 'account_card_current_account',
  AVAILABLE_ACCOUNT: 'account_card_available_account',
  ACC_NO: 'account_card_acc_no',
}

export const ACCOUNT_DETAILS_KEYS = {
  VIEW_ACCOUNT_DETAILS: 'account_details_view',
  ACCOUNT_TYPE: 'account_details_account_type',
  ACCOUNT_NICK_NAME: 'account_details_account_nick_name',
  ACCOUNT_HOLDER_NAME: 'account_details_account_holder_name',
  CUSTOMER_ID: 'account_details_customer_id',
  BRANCH: 'account_details_branch',
  SORT_CODE: 'account_details_sort_code',
  SWIFT_CODE: 'account_details_swift_code',
  CURRENCY: 'account_details_currency',
  AVAILABLE_BALANCE: 'account_details_available_balance',
  ACCOUNT_DESCRIPTION: 'account_details_account_description',
  ACCOUNT_OPEN_DATE: 'account_details_account_open_date',
  SAVING_ACC: 'account_details_saving_account',
  CURRENT_ACC: 'account_details_current_account',
  WALLET_ACC: 'account_details_wallet_account',
}

export const SET_ACCOUNT_NAME_KEYS = {
  HEADER: 'set_account_name_header',
  ACCOUNT_NO: 'set_account_name_account_no',
  SHORT_NAME: 'set_account_name_short_name',
  SELECT_ACCOUNT_NO: 'set_account_name_select_account_no',
}

export const BENEFICIARY_TRANSFER_KEYS = {
  HEADER: 'beneficiary_transfer_header',
  WITH_IN_BANK: 'beneficiary_transfer_with_in_bank',
  DOMESTIC: 'beneficiary_transfer_domestic',
  INTERNATIONAL: 'beneficiary_transfer_international',
  MY_ACCOUNTS: 'beneficiary_transfer_my_accounts',
  NO_ACCOUNTS: 'beneficiary_transfer_no_accounts',
  SEARCH: 'beneficiary_transfer_search',
  TITLE_INTERNAL: 'beneficiary_transfer_title_internal',
  TRANSFER_AMOUNT: 'beneficiary_transfer_transfer_amount',
  HAS_FX_DEAL: 'beneficiary_transfer_has_fx_deal',
  YES: 'beneficiary_transfer_yes',
  NO: 'beneficiary_transfer_no',
  FX_REF_NO: 'beneficiary_transfer_fx_ref_no',
  BANK_ALERT: 'beneficiary_transfer_bank_alert',
  SCHEDULED_PAYMENT: 'beneficiary_transfer_scheduled_payment',
  SCHEDULED_DATE: 'beneficiary_transfer_scheduled_date',
  REMARKS: 'beneficiary_transfer_remarks',
  CHARGES: 'beneficiary_transfer_charges',
  CURRENCY: 'beneficiary_transfer_currency',
  TITLE_DOMESTIC: 'beneficiary_transfer_title_domestic',
  TRANSFER_TYPE: 'beneficiary_transfer_transfer_type',
  RTGS: 'beneficiary_transfer_rtgs',
  DDACC: 'beneficiary_transfer_ddacc',
  TITLE_INTERNATIONAL: 'beneficiary_transfer_title_international',
  SENDER_TO_RECEIVER: 'beneficiary_transfer_sender_to_receiver',
  CHARGE_BEARER: 'beneficiary_transfer_charge_bearer',
  CHOOSE_FILE: 'beneficiary_transfer_choose_file',
  INVOICE_SUBMIT: 'beneficiary_transfer_invoice_submit',
  SWIFT: 'beneficiary_transfer_swift',
  TITLE_OWN: 'beneficiary_transfer_title_own',
  IAT: 'beneficiary_transfer_iat',
  REGIONAL: 'beneficiary_transfer_regional',
  TITLE_REGIONAL: 'beneficiary_transfer_title_regional',
}

export const BENEFICIARY_DROP_TARGET_KEYS = {
  HEADER: 'beneficiary_drop_target_header',
  AVAILABLE_BALANCE: 'beneficiary_drop_target_available_balance',
}

export const BENEFICIARY_VIEW_KEYS = {
  HEADER: 'beneficiary_view_header',
  WITH_IN_BANK: 'beneficiary_view_with_in_bank',
  DOMESTIC: 'beneficiary_view_domestic',
  INTERNATIONAL: 'beneficiary_view_international',
  SEARCH: 'beneficiary_view_search',
  ADD_NEW: 'beneficiary_view_add_new',
  BENEFICIARY_NAME: 'beneficiary_view_beneficiary_name',
  ACCOUNT_NO: 'beneficiary_view_account_no',
  TRANSFER_LIMIT: 'beneficiary_view_transfer_limit',
  BRANCH_CODE: 'beneficiary_view_branch_code',
  EMAIL_ID: 'beneficiary_view_email_id',
  MOBILE_NO: 'beneficiary_view_mobile_no',
  SHORT_NAME: 'beneficiary_view_short_name',
  BENEFICIARY_TYPE: 'beneficiary_view_baneficiary_type',
  REGIONAL: 'beneficiary_view_regional',
}

export const ADD_BENEFICIARY_KEYS = {
  INTERNAL_BENEFICIARY: 'add_internal_beneficiary',
  DOMESTIC_BENEFICIARY: 'add_domestic_beneficiary',
  INTERNATIONAL_BENEFICIARY: 'add_international_beneficiary',
  BENEFICIARY_NAME: 'add_beneficiary_name',
  NICK_NAME: 'add_beneficiary_nick_name',
  ACCOUNT_NO: 'add_beneficiary_account_no',
  CONFIRM_ACCOUNT_NO: 'add_beneficiary_confirm_account_no',
  BENEFICIARY_BANK: 'add_beneficiary_bank',
  BRANCH_NAME: 'add_beneficiary_branch_name',
  BENE_EMAIL_ID: 'add_beneficiary_email_id',
  BENE_MOBILE_NO: 'add_beneficiary_mobile_no',
  TRANSFER_LIMIT: 'add_beneficiary_transfer_limit',
  VISIBLE_GROUP: 'add_beneficiary_visible_group',
  DOMESTIC_BENE_HEADER: 'add_beneficiary_domestic_header',
  BRANCH_CODE: 'add_beneficiary_branch_code',
  BENEFICIARY_CURRENCY: 'add_beneficiary_currency',
  INTERNAL_BENE_HEADER: 'add_beneficiary_internal_header',
  ADDRESS: 'add_beneficiary_address',
  BENEFICIARY_COUNTRY: 'add_beneficiary_country',
  MODE_OF_TRANSFER: 'add_beneficiary_mode_of_transfer',
  SWIFT_BIC_CODE: 'add_beneficiary_swift_bic_code',
  IFSC_CODE: 'add_beneficiary_ifsc_code',
  ROUTING_NUMBER: 'add_beneficiary_routing_number',
  BANK_ADDRESS: 'add_beneficiary_bank_address',
  BANK_COUNTRY: 'add_beneficiary_bank_country',
  INTERNATIONAL_BENE_HEADER: 'add_beneficiary_international_header',
  ADD_BENEFICIARY_HEADER: 'add_beneficiary_header',
  TRANSFER_LIMIT_TXT: 'transfer_limit_txt',
  REGIONAL_BENEFICIRAY: 'add_regional_beneficiary',
  REGIONAL_BENE_HEADER: 'add_beneficiary_regional_header',
}

export const EDIT_BENEFICIARY_KEYS = {
  MODIFY_BENE_IMAGE: 'edit_beneficiary_modify_bene_image',
  IMAGE_SIZE_MESSAGE: 'edit_beneficiary_image_size_message',
  BENEFICIARY_NAME: 'edit_beneficiary_name',
  ACCOUNT_NUMBER: 'edit_beneficiary_account_number',
  SHORT_NAME: 'edit_beneficiary_short_name',
  TRANSFER_LIMIT: 'edit_beneficiary_transfer_limit',
  MAX_TRANSFER_AMOUNT: 'edit_beneficiary_max_transfer_amount',
  NICK_NAME: 'edit_beneficiary_nick_name',
  INTERNAL_BENE_HEADER: 'edit_internal_beneficiary_header',
  BENE_EMAIL_ID: 'edit_beneficiary_email_id',
  BENE_MOBILE_NO: 'edit_beneficiary_mobile_no',
  DOMESTIC_BENE_HEADER: 'edit_domestic_beneficiary_header',
  INTERNATIONAL_BENE_HEADER: 'edit_international_beneficiary_header',
  TRANSFER_LIMIT_TXT: 'transfer_limit_txt',
  REGIONAL_BENE_HEADER: 'edit_regional_beneficiary_header',
}

export const BI_STATEMENT_KEYS = {
  ACCOUNT_NO: 'bi_statement_account_no',
  FROM_DATE: 'bi_statement_form_date',
  TO_DATE: 'bi_statement_to_date',
  FORMAT: 'bi_statement_format',
  REPORT_NAME: 'bi_statement_report_name',
  HEADER: 'bi_statement_header',
  SELECT_ACCOUNT_NO: 'bi_statement_select_account_no',
}

export const DEPOSITS_KEYS = {
  CREATE_DEPOSIT: 'deposits_create',
  HEADER: 'deposits_header',
  // DESCRIPTION: 'deposits_description',
  STATEMENT_DETAILS: 'deposits_statement_details',
  VIEW_DETAILS: 'deposits_view_details',
  ACCOUNT_NUMBER: 'deposits_account_number',
  NO_ACCOUNTS: 'deposits_no_accounts',
  NARRATION: 'deposits_narration',
  TRANSACTION_DATE: 'deposits_transaction_date',
  SL_NUMBER: 'deposits_sl_number',
  REF_NO: 'deposits_ref_no',
  AMOUNT: 'deposits_amount',
  ACC_NO: 'deposits_acc_no',
  REF_NUMBER: 'deposits_ref_number',
  NO_STATEMENT: 'deposits_no_statement',
  TD_AMT: 'deposits_td_amt',
  STATUS: 'deposits_status',
  PROD_CATEGORY: 'deposits_prod_category',
  MATURITY_DATE: 'deposits_maturity_date',
  MATURITY_AMT: 'deposits_maturity_amt',
  DEBIT_ACC_BRN: 'deposits_debit_acc_brn',
  DEBIT_ACC: 'deposits_debit_acc',
  CUSTOMER_ID: 'deposits_customer_id',
  CURRENCY: 'deposits_currency',
  BRN_CODE: 'deposits_brn_code',
  ACCOUNT_OPEN_DATE: 'deposits_account_open_date',
  ACC_DESC: 'deposits_acc_desc',
  ACCOUNT_NO: 'deposits_account_no',
}

export const DETAILED_STATEMENT_KEYS = {
  FROM_DATE: 'detailed_statement_from_date',
  TO_DATE: 'detailed_statement_to_date',
  FORMAT: 'detailed_statement_format',
  REPORT_NAME: 'detailed_statement_report_name',
  HEADER: 'detailed_statement_header',
  DESCRIPTION: 'detailed_statement_description',
  CURRENT_MONTH_HEADER: 'detailed_statement_current_month_header',
  LAST_TWO_MONTH_HEADER: 'detailed_statement_last_two_month_header',
  LAST_THREE_MONTH_HEADER: 'detailed_statement_last_three_month_header',
  CUSTOM_RANGE_HEADER: 'detailed_statement_custom_range_header',
  CURRENT_MONTH_DESC: 'detailed_statement_current_month_desc',
  LAST_TWO_MONTH_DESC: 'detailed_statement_last_two_month_desc',
  LAST_THREE_MONTH_DESC: 'detailed_statement_last_three_month_desc',
  CUSTOM_RANGE_DESC: 'detailed_statement_custom_range_desc',
  NO_TRANSACTION_FOUND: 'detailed_statement_no_transaction_found',
  FROM_DATE_SELECT: 'detailed_statement_from_date_select',
  TO_DATE_SELECT: 'detailed_statement_to_date_select',
}

export const LOANS_KEYS = {
  HEADER: 'loans_header',
  DESCRIPTION: 'loans_description',
  STATEMENT_DETAILS: 'loans_statement_details',
  VIEW_DETAILS: 'loans_view_details',
  LOAN_ACCOUNT_NUMBER: 'loans_loan_account_number',
  NO_LOAN_ACCOUNTS: 'loans_no_loan_account',
  NARRATION: 'loans_narration',
  TRANSACTION_DATE: 'loans_transaction_date',
  SL_NUMBER: 'loans_sl_number',
  SETTELED_ACCOUNT_NO: 'loans_setteled_account_no',
  REF_NO: 'loans_ref_no',
  AMOUNT: 'loans_amount',
  ACC_NO: 'loans_acc_no',
  REF_NUMBER: 'loans_ref_number',
  NO_STATEMENT: 'loans_no_statement',
  VALUE_DATE: 'loans_value_date',
  REMAINING_NO_REPAYMENT: 'loans_remaining_no_repayment',
  STATUS: 'loans_status',
  REPAYMENT_STATUS: 'loans_repayment_status',
  REPAYMENT_INSTALLMENT: 'loans_repayment_installment',
  PRINCIPLE_AMOUNT: 'loans_principle_amout',
  MATURITY_DATE: 'loans_maturity_date',
  PROD_CATEGORY: 'loans_prod_category',
  OUT_STANDING_BALANCE: 'loans_out_standing_balance',
  NEXT_PAYMENT_DATE: 'loans_next_payment_date',
  INTEREST_RATE: 'loans_interest_rate',
  CUSTOMER_ID: 'loans_customer_id',
  CURRENCY: 'loans_currency',
  BRN_CODE: 'loans_brn_code',
  AMOUNT_PAID: 'loans_amount_paid',
  ACCOUNT_NO: 'loans_account_no',
  ACC_DESC: 'loans_acc_desc',
  USER_REF_NO: 'loans_user_ref_no',
}

export const STATEMENT_KEYS = {
  HEADER: 'statement_header',
  DESCRIPTION: 'statement_description',
  DETAILED_STATEMENT: 'statement_detailed_statement',
  NO_TRANSACTION: 'statement_no_transactions',
  REF_NO: 'statement_ref_no',
  CURRENCY: 'statement_currency',
  AMOUNT: 'statement_amount',
  TXN_TYPE_DESC: 'statement_txn_type_desc',
  TRANSACTION_DATE: 'statement_transaction_date',
  DEBIT_CREDIT: 'statement_debit_credit',
  REMARKS: 'statement_remarks',
  DOWNLOAD_STATEMENT: 'statement_download_statement',
  DOWNLOADING: 'statement_downloading',
}

export const CALCULATOR_KEYS = {
  LOANS: 'calculator_loans',
  DEPOSITS: 'calculator_deposits',
  INTEREST_AMOUNT: 'calculator_interest_amount',
  MONTHLY_INSTALMENT: 'calculator_monthly_instalment',
  MATURITY_AMOUNT: 'calculator_maturity_amount',
  TOTAL_AMOUNT: 'calculator_total_amount',
  INTEREST_RATE: 'calculator_interest_rate',
  TENURE: 'calculator_tenure',
  DEPOSIT_AMOUNT: 'calculator_deposit_amount',
  LOAN_AMOUNT: 'calculator_loan_amount',
}

export const EXCHANGE_RATES_KEYS = {
  CONVERSION_TYPE: 'exchange_rates_conversion_type',
  BUY_PRICE: 'exchange_rates_buy_price',
  SELL_PRICE: 'exchange_rates_sell_price',
}

export const TERMS_CONDITIONS_KEYS = {
  HEADER: 'terms_condition_header',
  CONFIRM_MESSAGE: 'terms_condition_confirm_message',
}

export const REQUEST_CHEQUE_KEYS = {
  CHEQUE_BOOK: 'request_cheque_book',
  CHEQUE_BOOK_DESCRIPTION: 'request_cheque_book_desc',
  STOP_CHEQUE: 'request_cheque_stop_cheque',
  STOP_CHEQUE_DESCRIPTION: 'request_cheque_stop_cheque_desc',
  CHEQUE_STATUS: 'request_cheque_status',
  CHEQUE_STATUS_DESC: 'request_cheque_status_desc',
}

export const REQUEST_DEBIT_CARD_KEYS = {
  CARD_REQUEST: 'card-request',
  CARD_REQUEST_DESCRIPTION: 'card-request-desc',
}

export const BLOCK_CARD_KEYS = {
  BLOCK_CARD: 'block_card',
  BLOCK_CARD_DESCRIPTION: 'block_card_desc',
  BLOCK_CARD_TITLE: 'block_card_title',
  CARD_NUMBER: 'block_card_card_number',
  REMARKS: 'block_card_remarks',
  BLOCK_CARD_CONFIRM_TITLE: 'block_card_confirm_title',
}

export const BENEFICIARY_DOWNLOAD_KEYS = {
  DOWNLOAD_RECEIPT: 'beneficiary_download_receipt',
  BI_STATEMENT: 'beneficiary_download_bi_statement',
  INTERNATIONAL_REMITTANCE_RECEIPT: 'beneficiary_download_international_remittance',
  SALARY_FILE_STATUS: 'beneficiary_download_salary_file_status',
  VIEW_SCHEDULED_TRANSFER: 'beneficiary_download_view_scheduled_transfer',
}

export const DOWNLOAD_CENTER_KEYS = {
  DOWNLOAD_RECEIPT: 'download_center_download_receipt',
  BI_STATEMENT: 'download_center_download_bi_statement',
  INTERNATIONAL_REMITTANCE_RECEIPT: 'download_center_international_remittance',
  SALARY_FILE_STATUS: 'download_center_download_salary_file_status',
  VIEW_SCHEDULED_PAYMENT: 'download_center_download_view_scheduled_payment',
}

export const SUPPORT_CENTER_KEYS = {
  LOCATE_US: 'support_center_locateUs',
  FAQ: 'support_center_faq',
  SUGGESTIONS: 'support_center_suggestions',
  CONTACT_US: 'support_center_contact_us',
  ABOUT_US: 'support_center_about_us',
  LOCATE_US_DESCRIPTION: 'support_center_locateUs_desc',
  FAQ_DESCRIPTION: 'support_center_faq_desc',
  SUGGESTIONS_DESCRIPTION: 'support_center_suggestions_desc',
  CONTACT_US_DESCRIPTION: 'support_center_contact_us_desc',
  ABOUT_US_DESCRIPTION: 'support_center_about_us_desc',
  FOLLOW_ON: 'support_center_follow_on',
}

export const MT103_KEYS = {
  ACCOUNT_NO: 'mt103_account_no',
  SELECT_ACCOUNT_NO: 'mt103_select_account_no',
  FROM_DATE: 'mt103_from_date',
  TO_DATE: 'mt103_to_date',
  REFERENCE_NO: 'mt103_reference_no',
  NO_RECORDS_FOUND: 'mt103_no_records_found',
  TITLE: 'mt103_title',
}

export const SALARY_FILE_STATUS_KEYS = {
  RQUEST_ID: 'salary_file_status_request_id',
  FILE: 'salary_file_status_file',
  AUTHORIZED_BY: 'salary_file_status_authorized_by',
  STATUS: 'salary_file_status_status',
  SOURCE_ACCOUNT: 'salary_file_status_source_account',
  TYPE_OF_FILE: 'salary_file_status_type_of_file',
  CURRENCY: 'salary_file_status_currency',
  CUSTOMER_ID: 'salary_file_status_customer_id',
  NO_RECORDS_FOUND: 'salary_file_status_no_records_found',
  TITLE: 'salary_file_status_title',
  FILE_STATUS: 'salary_file_status_file_status',
  INVALID_FILES: 'salary_file_status_invalid_files',
}

export const VIEW_SCHEDULED_PAYMENT_KEYS = {
  SOURCE_ACCOUNT: 'view_scheduled_payment_source_account',
  SCHEDULED_DATE: 'view_scheduled_payment_scheduled_date',
  AMOUNT: 'view_scheduled_payment_amount',
  ACTION: 'view_scheduled_payment_action',
  REFERENCE_NO: 'view_scheduled_payment_refernce_no',
  ID: 'view_scheduled_payment_id',
  DESTINATION_ACCOUNT: 'view_scheduled_payment_destination_account',
  SERVICE_CODE: 'view_scheduled_payment_service_code',
  ACTIVE_STATUS: 'view_scheduled_payment_active_status',
  CREATED_DATE: 'view_scheduled_payment_created_date',
  TXN_STATUS: 'view_scheduled_payment_txn_status',
  SOURCE_ACCOUNT_CURRENCY: 'view_scheduled_payment_source_account_currency',
  TXN_CURRENCY: 'view_scheduled_payment_txn_currency',
  REMARKS: 'view_scheduled_payment_remarks',
  NO_RECORDS_FOUND: 'view_scheduled_payment_no_records_found',
  OTP: 'view_scheduled_payment_otp',
  ENTER_OTP: 'view_scheduled_payment_enter_otp',
}

export const DOWNLOAD_RECEIPT_KEYS = {
  FROM_DATE: 'download_receipt_from_date',
  TO_DATE: 'download_receipt_to_date',
  RECEIPT_ID: 'download_receipt_receipt_id',
  TRANSFER_TYPE: 'download_receipt_transfer_type',
  TRANSATION_TIME: 'download_receipt_transanction_time',
  ACTION: 'download_receipt_action',
  TRANSACTION_REF_NO: 'download_receipt_transaction_ref_no',
  TRANSACTION_DATE: 'download_receipt_transaction_date',
  REQUESTS_DESCRIPTION: 'download_receipt_request_desc',
  SOURCE_ACCOUNT: 'download_receipt_source_account',
  DESTINATION_ACCOUNT: 'download_receipt_destination_account',
  AMOUNT: 'download_receipt_amount',
  REMARKS: 'download_receipt_remarks',
  USERNAME: 'download_receipt_username',
  NO_RECORDS_FOUND: 'download_receipt_no_records_found',
  TITLE: 'download_receipt_title',
}

export const BULK_TRANSFER_KEYS = {
  TITLE: 'bulk_transafer_title',
  REF_NO: 'bulk_transafer_ref_no',
  ACCOUNT_NO: 'bulk_transafer_account_no',
  BENEFICIARY_NAME: 'bulk_transafer_beneficiary_name',
  TRANSFER_TYPE: 'bulk_transafer_transafer_type',
  AMOUNT: 'bulk_transafer_amount',
  REAPONSE: 'bulk_transafer_response',
  REMARKS: 'bulk_transafer_remarks',
  TRANSFER_AMOUNT: 'bulk_transafer_transafer_amount',
  TXN_CURRENCY: 'bulk_transfer_txn_currency',
  NO_RECORDS: 'bulk_transafer_no_records',
}

export const QUICK_PAY_KEYS = {
  TITLE: 'quick_pay_title',
  ACCOUNT_TYPE: 'quick_pay_account_type',
  CONFIRM_ACCOUNT_NO: 'quick_pay_confirm_account_no',
  SELECT_BANK: 'quick_pay_select_bank',
  SELECT_BRANCH: 'quick_pay_select_branch',
  REMARKS: 'quick_pay_remarks',
  ADD_BENEFICIARY: 'quick_pay_add_beneficiary',
  NOTE: 'quick_pay_note',
  CONFIRM_TRANSFER: 'quick_pay_confirm_transfer',
  TRANSFER_MODE: 'quick_pay_transfer_mode',
  BANK: 'quick_pay_bank',
  BRANCH: 'quick_pay_branch',
  BIC_CODE: 'quick_pay_bic_code',
  SORT_CODE: 'quick_pay_sort_code',
  BENEFICIARY_NAME: 'quick_pay_beneficiary_name',
  BENEFICIARY_ACCOUNT_NO: 'quick_pay_beneficiary_account_no',
  BENEFICIARY_BRANCH: 'quick_pay_beneficairy_branch',
  BENEFICIARY_CURRENCY: 'quick_pay_beneficiary_currency',
  AMOUNT: 'quick_pay_amount',
  CHARGES: 'quick_pay_charges',
  ADD_AS_BENEFICIARY: 'quick_pay_add_as_beneficiary',
  ACCOUNT_NO: 'quick_pay_account_no',
  INTERNAL: 'quickPay_instant_transfer_iat',
  DDACC_TRANSFER: 'quickPay_instant_transfer_ddacc',
  RTGS_TRANSFER: 'quickPay_instant_transfer_rtgs',
  REGION_TRANSFER: 'quickPay_region_transfer',
  TRANSCTION_CURRRENCY: 'quickPay_transcation_currency',
}

export const SALARY_UPLOAD_KEYS = {
  CLICK_OR_DRAG: 'salary_upload_click_or_drag',
  ACCOUNT_NO: 'salary_upload_account_no',
  TITLE: 'salary_upload_title',
  TEMPLATE: 'salary_upload_template',
  DOMESTIC: 'salary_upload_domestic',
  INTERNATIONAL: 'salary_upload_international',
  ERP: 'salary_upload_erp',
  PROCESS_NAME: 'salary_upload_process_name',
  VALUE_DATE: 'salary_upload_value_date',
  TOTAL_AMOUNT: 'salary_upload_total_amount',
  NARRATIVE: 'narrative_txt',
}
export const ADD_BILLER_KEYS = {
  TITLE: 'add_biller_title',
  SELECT_MERCHANT: 'add_biller_select_merchant',
  SERVICE_NO_MOBILE_NO: 'add_biller_service_no_mobile_no',
  SHORT_NAME: 'add_biller_short_name',
  SERVICE_NO: 'add_biller_service_no',
  NO: 'add_biller_no',
}

export const VIEW_BILLER_KEYS = {
  TITLE: 'view_biller_title',
  NO_RECORDS: 'view_biller_no_records',
  SHORT_NAME: 'view_biller_short_name',
  MERCHANT: 'view_biller_merchant',
  DELETE_MESSAGE: 'view_biller_delete_message',
  SERVICE_NO: 'view_biller_service_no',
}

export const PAYMENT_KEYS = {
  NOTE: 'payment_note',
  PRODUCT: 'payment_product',
  SHOW_BENEFICIARY: 'payment_show_beneficiary',
  NO_BENEFICIARY: 'payment_no_beneficiary',
  AMOUNT: 'payment_amount',
  SCHEDULED_PAYMENT: 'payment_scheduled_payment',
  SCHEDULED_DATE: 'payment_scheduled_date',
  REMARKS: 'payment_remarks',
  SERVICE_NO: 'payment_service_no',
  BILLER_NAME: 'payment_biller_name',
  QUOTE_ID: 'payment_quote_id',
  BILL_NO: 'bill_no',
  BILL_DATE: 'bill_date',
  BILL_DUE_DATE: 'bill_due_date',
  MOBILE_NO: 'product_mobile_no',
  STUDENT_NO: 'product_student_no',
  ACCOUNT_NO: 'product_account_no',
  BILL_NUMBER: 'product_bill_no',
  SUBSCRIBER_NO: 'product_subscriber_no',
  IS_REQUIRED: 'validation_required',
  CUSTOM_REMARKS: 'payment_custom_remarks',
  INSURANCE_NO: 'payment_insurance_no',
  SERVICENO: 'payment_serviceno',
  CUSTOMER_NAME: 'payment_customer_name',
  CUSTOMER_ADDRESS: 'payment_customer_address',
  AMOUNT_DUE: 'payment_amount_due',
  BENEFICIARY: 'payment_beneficiary',
  CUSTOMER_NO: 'payment_customer_number',
  SCHOOL_BENE_BANK_TYPE: 'school_bene_bank_type',
  SCHOOL_BENE_BANK: 'school_bene_bank',
  STUDENT_CLASS_NAME: 'student_class_txt',
  CLASS_NAME: 'class_name',
  SCHOOL_NAME: 'school_name',
  STUDENT_NAME: 'student_name',
  SCHOOL_TERM: 'school_term',
  FEES_PURPOSE: 'fees_purpose',
  SCHOOL_YEAR: 'school_year',
  PAYMENT_CUSTOMER_NAME: 'bill_payment_customer_name',
}

export const SUPPORT_CENTER_LOCATE_US_KEYS = {
  BRANCH: 'support_center_locateUs_branch',
  ATM: 'support_center_locateUs_atm',
  CHOOSE_OPTION: 'support_center_locateUs_choose_option',
  LOCATION_NO_INFO: 'location_no_info',
}

export const SUPPORT_CENTER_FAQ_KEYS = {
  TITLE: 'support_center_faq_title',
}

export const SUPPORT_CENTER_SUGGESTION_KEYS = {
  TITLE: 'support_center_suggestion_title',
  SELECT_FEEDBACK: 'support_center_suggestion_select_feedback',
  WRITE_FEEDBACK: 'support_center_suggestion_write_feedback',
}

export const CHEQUE_BOOK_REQUEST_KEYS = {
  TITLE: 'cheque_book_request_title',
  PICK_UP_BRANCH: 'cheque_book_request_pick_up_branch',
  NO_OF_LEAVES: 'cheque_book_request_no_of_leaves',
  NO_OF_BOOKS: 'cheque_book_request_no_of_books',
  CONFIEM_TITLE: 'cheque_book_request_confirm_title',
}

export const STOP_CHEQUE_KEYS = {
  TITLE: 'stop_cheque_title',
  INDIVIUAL_CHEQUE: 'stop_cheque_indiviual_cheque',
  RANGE_OF_CHEQUE: 'stop_cheque_range_of_cheque',
  CHEQUE_NO: 'stop_cheque_cheque_no',
  START_CHEQUE_NO: 'stop_cheque_start_cheque_no',
  END_CHEQUE_NO: 'stop_cheque_end_cheque_no',
  REASON: 'stop_cheque_reason',
  EFFECTIVE_DATE: 'stop_cheque_effective_date',
  REMARKS: 'stop_cheque_remarks',
  CONFIRM_TITLE: 'stop_cheque_confirm_title',
}

export const STANDING_INSTRUCTION_KEYS = {
  TITLE: 'standing_instruction_title',
  CREATE_SI: 'standing_instruction_credit_si',
  REFERENCE_NO: 'standing_instruction_reference_no',
  AMOUNT: 'standing_instruction_amount',
  BENEFICIARY_ACCOUNT: 'standing_instruction_beneficiary_account',
  BRANCH_CODE: 'standing_instruction_branch_code',
  CONTRACT_REF_NO: 'standing_instruction_contract_ref_no',
  CREDIT_ACC_DESC: 'standing_instruction_credit_acc_desc',
  CURRENCY: 'standing_instruction_currency',
  CUSTOMER_NO: 'standing_instruction_customer_no',
  CYCLE_START_DATE: 'standing_instruction_cycle_start_date',
  DAYS: 'standing_instruction_days',
  DESCRIPTION: 'standing_instruction_description',
  EXPIRY_DATE: 'standing_instruction_expiry_date',
  FREQUENCY: 'standing_instruction_frequency',
  MONTHS: 'standing_instruction_months',
  NEXT_EXEC_DATE: 'standing_instruction_next_exec_date',
  PROD_CATEGORY: 'standing_instruction_prod_category',
  PROD_CODE: 'standing_instruction_prod_code',
  REMARKS: 'standing_instruction_remarks',
  SI_TYPE: 'standing_instruction_si_type',
  SOURCE_ACCOUNT: 'standing_instruction_source_account',
  STATUS: 'standing_instruction_status',
  YEARS: 'standing_instruction_years',
  NO_RECORDS: 'standing_instruction_no_records',
}

export const CREATE_SI_KEYS = {
  TITLE: 'create_si_title',
  REQUEST_TYPE: 'create_si_request_type',
  REQUEST_TYPE_OPTION: 'create_si_request_type_option',
  SELECT_BANK: 'create_si_select_bank',
  SELECT_BRANCH: 'create_si_select_branch',
  START_DATE: 'create_si_start_date',
  END_DATE: 'create_si_end_date',
  MONTH_END: 'create_si_month_end',
  DAYS: 'create_si_days',
  MONTH: 'create_si_month',
  YEAR: 'create_si_year',
  AMOUNT: 'create_si_amount',
  REMARK: 'create_si_remark',
  CONFIRM_TITLE: 'create_si_confirm_title',
  CREDIT_ACCOUNT_NO: 'create_si_credit_account_no',
  CREDIT_ACC_NO: 'create_si_credit_acc_no',
}

export const RECEIPTS_KEYS = {
  RECEIPT_ID: 'receipt_reciepts',
  TRANFER_TYPE: 'receipt_transfer_type',
  TRANSACTION_DATE: 'receipt_keys_transaction_date',
  SERVICENO: 'receipt_service_number',
  TRANSACTION: 'receipt_transaction',
  ACTIONS: 'receipt_actions',
  DOWNLOAD: 'receipt_download',
  ACCOUNTNO: 'receipt_account_number',
  NORECEIPTS: 'receipt_no_reciepts',
  SENDER_ACCOUNT: 'receipt_sender_account',
  OAT: 'receipt_oat',
  RTGS: 'receipt_rtgs',
  IAT: 'receipt_iat',
  SWIFT: 'receipt_swift',
  DDACC: 'receipt_ddacc',
  REMARKS: 'receipt_keys_remarks',
  AMOUNT: 'receipt_keys_amount',
  BENE_NAME: 'receipt_keys_bene_name',
  TRANS_CURRENCY: 'receipt_keys_bene_currency',
  TO_ACCOUNT: 'receipt_keys_to_account',
  FROM_ACCOUNT: 'receipt_keys_from_account',
  REF_ID: 'receipt_keys_ref_id',
  SERVICE_NO: 'receipt_keys_service_no',
  TRANSFERS: 'receipt_keys_transfer',
  PAYMENTS: 'receipt_keys_payment',
  FORM_DATE: 'receipt_keys_from_date',
  TO_DATE: 'receipt_keys_to_date',
  SEARCH: 'receipt_keys_search',
}

export const APPROVAL_MENU_KEYS = {
  STOP_CHEQUE: 'approval_menu_stop_cheque',
  STANDING_INSTRUCTION: 'approval_menu_si',
  PAYMENTS: 'approval_menu_payments',
  CHEQUE_BOOK: 'approval_menu_cheque_book',
  FUND_TRANSFER: 'approval_menu_fund_transfer',
  SALARY_UPLOAD: 'approval_menu_salary_upload',
  BENEFICIARY: 'approval_menu_beneficiary',
  TERM_DEPOSIT: 'approval_menu_term_deposit',
  DEBIT_CARD: 'approval_menu_debit_card',
  BLOCK_CARD: 'approval_menu_block_card',
}

export const APPROVAL_COMMON_KEYS = {
  DELETE_MESSAGE: 'approval_common_delete_message',
  NO_RECORDS_FOUND: 'approval_common_no_records_found',
  SELECT_ALL: 'approval_common_select_all',
  APPROVE: 'approval_common_approve',
  REJECT: 'approval_common_reject',
  VIEW_DETAILS: 'approval_common_view_details',
  VIEW_COMMENTS: 'approval_common_view_comment',
  DELETE: 'approval_common_delete',
  NO_COMMENTS_FOUND: 'approval_common_no_comment_found',
  WRITE_COMMENT: 'approval_common_write_comment',
  MESSAGE: 'approval_common_message',
  STATUS: 'approval_common_status',
  ACCOUNT_NO: 'approval_common_account_no',
  REQUEST_ID: 'approval_common_request_id',
  AUTHORIZER: 'approval_common_authorizer',
  AUTH_LEVEL: 'approval_common_auth_level',
  COMMENTS: 'approval_common_comments',
  VERIFY: 'approval_common_verify',
  MOBILE_NO: 'header_details_mobile_no',
  AMOUNT: 'header_details_amount',
  EXPIRY: 'header_details_expiry',
}

export const APPROVAL_CHEQUE_BOOK_KEYS = {
  TITLE: 'approval_cheque_book_title',
  NO_OF_LEAVES: 'approval_cheque_book_no_of_leaves',
}

export const APPROVAL_BENEFICIARY_KEYS = {
  TITLE: 'approval_beneficiary_title',
  REFERENCE_NO: 'approval_beneficiary_reference_no',
  INTERNAL_BENEFICIARY: 'approval_beneficiary_internal',
  EXTERNAL_BENEFICIARY: 'approval_beneficiary_external',
}

export const APPROVAL_FUND_TRANSSFER_KEYS = {
  TITLE: 'approval_fund_transfer_title',
  REFERENCE_NO: 'approval_fund_transfer_reference_no',
}

export const APPROVAL_PAYMENT_KEYS = {
  TITLE: 'approval_payment_title',
  RECEIPT_NO: 'approval_payment_receipt_no',
  TRANSCTION_NO: 'approval_payment_transation_no',
  MERCHANT: 'approval_payment_merchant',
  REFERENCE_NO: 'approval_payment_reference_no',
}

export const APPROVAL_SALARY_UPLOAD_KEYS = {
  TITLE: 'approval_salary_upload_title',
  REFERENCE_NO: 'approval_salary_upload_reference_no',
  REF_ID: 'approval_salary_upload_ref_id',
  TOTAL_AMOUNT: 'approval_salary_upload_total_amount',
  SOURCE_ACCOUNT_NO: 'header_details_source_account_no',
  BRANCH_CODE: 'header_details_branch_code',
}

export const APPROVAL_SI_KEYS = {
  TITLE: 'approval_si_title',
  REFERENCE_NO: 'approval_si_reference_no',
}

export const APPROVAL_STOP_CHEQUE_KEYS = {
  TITLE: 'approval_stop_cheque_title',
  CHEQUE_NO: 'approval_stop_cheque_cheque_no',
}

export const APPROVAL_TERM_DEPOSIT_KEYS = {
  TITLE: 'approval_term_deposit_title',
  REFERENCE_NO: 'approval_term_deposit_reference_no',
  CREDIT_INTEREST_MONTHLY: 'approval_term_deposit_interest_monthly',
  CREDIT_INTEREST_ON_MATURITY: 'approval_term_deposit_interest_maturity',
  CREDIT_INTEREST_QUARTERLY: 'approval_term_deposit_interest_quarterly',
}

export const APPROVAL_DEBIT_CARD_KEYS = {
  TITLE: 'approval_debit_card_title',
}

export const APPROVAL_BLOCK_CARD_KEYS = {
  TITLE: 'approval_block_card_title',
}

export const HISTORY_MENU_KEYS = {
  STOP_CHEQUE: 'history_menu_stop_cheque',
  STANDING_INSTRUCTION: 'history_menu_si',
  PAYMENTS: 'history_menu_payments',
  CHEQUE_BOOK: 'history_menu_cheque_book',
  FUND_TRANSFER: 'history_menu_fund_transfer',
  SALARY_UPLOAD: 'history_menu_salary_upload',
  BENEFICIARY: 'history_menu_beneficiary',
  TERM_DEPOSIT: 'history_menu_term_deposit',
  CARDLESS_CASH: 'history_menu_cardless_cash',
  DEBIT_CARD: 'history_menu_debit_card',
  BLOCK_CARD: 'history_menu_block_card',
}

export const VIEW_CARD_LESS_CASH_DETAILS_KEYS = {
  ACCOUNT_NO: 'view_card_less_details_account_no',
  CURRENCY: 'view_card_less_details_currency',
  MOBILE_NO: 'view_card_less_details_mobile_no',
  EXPIRY: 'view_card_less_details_expiry',
  AMOUNT: 'view_card_less_details_amount',
  BRANCH: 'view_card_less_details_branch',
}

export const CARD_LESS_CASH_KEYS = {
  NO_RECORDS: 'card_less_cash_no_records',
  TOKEN_NO: 'card_less_cash_token_no',
  EXPIRY_DATE: 'card_less_cash_expiry_date',
  ACCOUNT_NO: 'card_less_cash_account_no',
  MOBILE_NO: 'card_less_cash_mobile_no',
  AMOUNT: 'card_less_cash_amount',
  CREATED_DATE: 'card_less_cash_created_date',
  STATUS: 'card_less_cash_status',
  CANCEL_TOKEN: 'card_less_cash_cancel_token',
  TITLE: 'card_less_cash_title',
  GENERATE_TOKEN: 'card_less_cash_generate_token',
  REMARKS: 'card_less_cash_remarks',
  CURRENCY: 'card_less_cash_currency',
  EXPIRY: 'card_less_cash_expiry',
  CHARGES: 'card_less_cash_charges',
  CANCEL: 'card_less_cash_cancel',
  SUBMIT: 'card_less_cash_submit',
  SEARCH_BY: 'card_less_cash_search_by',
  SELECT_STATUS: 'card_less_cash_select_status',
}

export const VIEW_DETAILS_COMMON_KEYS = {
  INITIATED_BY: 'view_details_initiated_by',
  INITIATED_DATE: 'view_details_initiated_date',
  AUTHORIZED_DATE: 'view_details_authorized_date',
  AUTHORIZED_STATUS: 'view_details_authorized_status',
  COMMENTS: 'view_details_comment',
  VALUE_DATE: 'view_details_value_date',
}

export const VIEW_BENEFICIARY_DETAILS_KEYS = {
  ACCOUNT_NO: 'view_bene_details_account_no',
  BENEFICIARY_NAME: 'view_bene_details_beneficiary_name',
  BRANCH: 'view_bene_details_branch',
  CURRENT_LEVEL: 'view_bene_details_current_level',
  BENEFICIARY_TYPE: 'view_bene_details_beneficiary_type',
  SORT_CODE: 'view_bene_details_sort_code',
  BIC_CODE: 'view_bene_details_bic_code',
  BANK_NAME: 'view_bene_details_bank_name',
  BANK_ADDRESS: 'view_bene_details_bank_address',
  NICK_NAME: 'view_bene_details_nick_name',
  BENEFICIARY_CURRENCY: 'view_bene_details_beneficiary_currency',
  TRANSFER_LIMIT: 'view_bene_details_transfer_limit',
  VISIBLE_TO_GROUP: 'view_bene_details_visible_to_group',
  OPERATION_TYPE: 'view_bene_details_operation_type',
}

export const VIEW_SALARY_UPLOAD_DETAILS_KEYS = {
  FILE_NAME: 'view_salary_upload_details_file_name',
  TYPE_OF_FILE: 'view_salary_upload_details_type_of_file',
  AMOUNT: 'view_salary_upload_details_amount',
  CURRENT_LEVEL: 'view_salary_upload_details_current_level',
  REQUEST_ID: 'view_salary_upload_details_request_id',
}

export const VIEW_FT_DETAILS_KEYS = {
  SENDER_ACCOUNT_NO: 'view_ft_details_sender_account_no',
  SENDER_BARNCH: 'view_ft_details_sender_branch',
  SENDER_CURRENCY: 'view_ft_details_sender_currency',
  AMOUNT: 'view_ft_details_amount',
  EMAIL_ID: 'view_ft_details_email_id',
  MOBILE_NO: 'view_ft_details_mobile_no',
  CURRENT_LEVEL: 'view_ft_details_current_level',
  RECEIVER_ACCOUNT_NO: 'view_ft_details_receiver_account_no',
  RECEIVER_BARNCH: 'view_ft_details_receiver_branch',
  RECEIVER_CURRENCY: 'view_ft_details_receiver_currency',
  BENEFICIARY_NAME: 'view_ft_details_beneficiary_name',
  TRANSFER_MODE: 'view_ft_details_transafer_mode',
  BIC_CODE: 'view_ft_details_bic_code',
  SORT_CODE: 'view_ft_details_sort_code',
  BANK_NAME: 'view_ft_details_bank_name',
  SWIFT_CODE: 'view_ft_details_swift_code',
  TRANSACTION_REF_NO: 'view_ft_details_transaction_ref_no',
  REMARKS: 'view_ft_details_remarks',
  OAT: 'oat',
  RTGS: 'rtgs',
  IAT: 'iat',
  SWIFT: 'swift',
  DDACC: 'ddacc',
  OTHER: 'other',
}

export const VIEW_PAYMENT_DETAILS_KEYS = {
  AMOUNT: 'view_payment_details_amount',
  CURRENT_LEVEL: 'view_payment_details_current_level',
  MERCHANT: 'view_payment_details_merchant',
  SERVICE_NO: 'view_payment_details_service_no',
  SERVICE_TYPE: 'view_payment_details_service_type',
  SOURCE_ACCOUNT_NO: 'view_payment_details_source_account_no',
  SOURCE_CURRENCY: 'view_payment_details_source_currency',
  SOURCE_BRANCH: 'view_payment_details_source_branch',
}

export const VIEW_CHEQUE_BOOK_DETAILS_KEYS = {
  ACCOUNT_NO: 'view_cheque_book_details_account_no',
  CURRENT_LEVEL: 'view_cheque_book_details_current_level',
  BRANCH: 'view_cheque_book_details_branch',
  ADDRESS: 'view_cheque_book_details_address',
  NO_OF_CHEQUE_LEAVES: 'view_cheque_book_details_no_of_cheque_leaves',
  NO_OF_CHEQUE_BOOK: 'view_cheque_book_details_no_of_cheque_book',
  PICK_UP_BRANCH: 'view_cheque_book_details_pick_up_branch',
}

export const VIEW_STOP_CHEQUE_DETAILS_KEYS = {
  ACCOUNT_NO: 'view_stop_cheque_details_account_no',
  CURRENT_LEVEL: 'view_stop_cheque_details_current_level',
  BRANCH: 'view_stop_cheque_details_branch',
  EFFECTIVE_DATE: 'view_stop_cheque_details_effective_date',
  START_CHEQUE_NO: 'view_stop_cheque_details_start_cheque_no',
  END_CHEQUE_NO: 'view_stop_cheque_details_end_cheque_no',
  REASON: 'view_stop_cheque_details_reason',
  STATUS: 'view_stop_cheque_details_status',
  AUTHORIZER_COMMENT: 'view_stop_cheque_details_authorizer_comment',
}

export const VIEW_TD_DETAILS_KEYS = {
  AMOUNT: 'view_td_details_amount',
  CURRENT_LEVEL: 'view_td_details_current_level',
  SOURCE_ACCOUNT_NO: 'view_td_details_source_account_no',
  CURRENCY: 'view_td_details_currency',
  SOURCE_BRANCH: 'view_td_details_source_branch',
  INTERST_OF_CREDIT: 'view_td_details_interest_of_credit',
  BRANCH_CODE: 'view_td_details_branch_code',
  CUSTOMER_ID: 'view_td_details_customer_id',
  CREDIT_ACCOUNT: 'view_td_details_credit_account',
  CREDIT_ACCOUNT_BRANCH: 'view_td_details_credit_account_branch',
  PRODUCT: 'view_td_details_product',
  DAYS: 'view_td_details_days',
  MONTHS: 'view_td_details_months',
  YEARS: 'view_td_details_years',
}

export const VIEW_SI_DETAILS_KEYS = {
  SENDER_ACCOUNT_NO: 'view_si_details_sender_account_no',
  SENDER_BARNCH: 'view_si_details_sender_branch',
  SENDER_CURRENCY: 'view_si_details_sender_currency',
  AMOUNT: 'view_si_details_amount',
  CURRENT_LEVEL: 'view_si_details_current_level',
  RECEIVER_ACCOUNT_NO: 'view_si_details_receiver_account_no',
  RECEIVER_BARNCH: 'view_si_details_receiver_branch',
  RECEIVER_CURRENCY: 'view_si_details_receiver_currency',
  TRANSFER_TYPE: 'view_si_details_transafer_type',
  REMARKS: 'view_si_details_remarks',
  ADDRESS: 'view_si_details_address',
  BANK_CODE: 'view_si_details_bank_code',
  MONTH_END: 'view_si_details_month_end',
  DAYS: 'view_si_details_days',
  MONTHS: 'view_si_details_months',
  YEARS: 'view_si_details_years',
  RECEIVER_NAME: 'view_si_details_receiver_name',
  EXPIRY_DATE: 'view_si_details_expiry_date',
  FIRST_VALUE_DATE: 'view_si_details_first_value_date',
}

export const VIEW_DEBIT_CARD_DETAILS_KEYS = {
  ACCOUNT_NO: 'view_debit_card_details_account_no',
  CURRENT_LEVEL: 'view_debit_card_details_current_level',
  BRANCH: 'view_debit_card_details_branch',
  CURRENCY: 'view_debit_card_details_currency',
  CARD_TYPE: 'view_debit_card_details_card_type',
}

export const VIEW_BLOCK_CARD_DETAILS_KEYS = {
  ACCOUNT_NO: 'view_block_card_details_account_no',
  CURRENT_LEVEL: 'view_block_card_details_current_level',
  BRANCH: 'view_block_card_details_branch',
  CURRENCY: 'view_block_card_details_currency',
  CARD_NO: 'view_block_card_details_card_no',
  CARD_STATUS: 'view_block_card_details_card_status',
}

export const HEADER_DETAILS_KEYS = {
  ACCOUNT_NO: 'header_details_account_no',
  FILE_NAME: 'header_details_file_name',
  REF_ID: 'header_details_ref_id',
  TOTAL_AMOUNT: 'header_details_total_amount',
  CHEQUE_NO: 'header_details_cheque_no',
  NO_OF_CHEQUE_LEAVES: 'header_details_no_of_cheque_leaves',
  SOURCE_ACCOUNT_NO: 'header_details_source_account_no',
  BRANCH_CODE: 'header_details_branch_code',
  MOBILE_NO: 'header_details_mobile_no',
  AMOUNT: 'header_details_amount',
  EXPIRY: 'header_details_expiry',
}

export const HISTORY_COMMON_KEYS = {
  DOWNLOAD: 'history_common_download',
  REJECT: 'history_common_reject',
  APPROVED: 'history_common_approved',
  NO_RECORDS_FOUND: 'history_common_no_records_found',
  BENEFICIARY_TITLE: 'history_common_beneficiary_title',
  CHEQUE_BOOK_TITLE: 'history_common_cheque_book_title',
  FUND_TRANSFER_TITLE: 'history_common_fund_trnasfer_title',
  PAYMENT_TITLE: 'history_common_payment_title',
  SALARY_UPLOAD_TITLE: 'history_common_salary_upload_title',
  SI_TITLE: 'history_common_si_title',
  TERM_DEPOSIT_TITLE: 'history_common_term_deposit_title',
  STOP_CHEQUE_TITLE: 'history_common_stop_cheque_title',
  DEBIT_CARD_TITLE: 'history_common_debit_card_title',
  BLOCK_CARD_TITLE: 'history_common_block_card_title',
}

export const LANDING_PAGE_KEYS = {
  HI: 'landing_hi',
  WELCOME: 'landing_welcome',
  BANK_NAME: 'landing_bank_name',
  BANKING: 'landing_banking',
  EXCHANGE_RATE: 'landing_exchange_rate',
  LOCATE_US: 'landing_locate_us',
  LOAN_ELIGIBLITY: 'landing_loan_eligiblity',
  CONTACT_US: 'landing_contact_us',
}

export const LANDING_AUTH_LAYOUT_KEYS = {
  TITLE: 'landing_auth_layout_title',
  SLOGAN_1: 'auth_getStarted_slogan_1',
  SLOGAN_2: 'auth_getStarted_slogan_2',
  SLOGAN_3: 'auth_getStarted_slogan_3',
  SLOGAN_4: 'auth_getStarted_slogan_4',
}

export const LANDING_EXCHANGE_RATE_KEYS = {
  CONVERSION_TYPE: 'landing_exchange_rate_conversion',
  BUY_PRICE: 'landing_exchange_rate_buy_price',
  SELL_PRICE: 'landing_exchange_rate_sell_price',
}

export const LANDING_CALCULATOR_KEYS = {
  DEPOSIT_AMOUNT: 'landing_calculator_deposite_amount',
  TENURE: 'landing_calculator_tenure',
  INTEREST_RATE: 'landing_calculator_interest_rate',
  LOAN_AMOUNT: 'landing_calculator_loan_amt',
  LOANS: 'landing_calculator_loans',
  DEPOSIT: 'landing_calculator_deposit',
  INTEREST_AMOUNT: 'landing_calculator_interest_amt',
  MONTHLY_INSTALMENT: 'landing_calculator_monthly_instalment',
  MATURITY_AMOUNT: 'landing_calculator_maturity_amt',
  TOTAL_AMOUNT: 'landing_calculator_total_amt',
}

export const LANDING_BRANCH_KEYS = {
  BRANCH: 'landing_branch',
  ATM: 'landing_branch_atm',
  CHOOSE_OPTION: 'landing_branch_choose_option',
  LOCATION_NO_INFO: 'location_no_info',
}

export const LOGIN_KEYS = {
  ENTER_USERNAME: 'login_enter_username',
  ENTER_PASSWORD: 'login_enter_password',
  USERNAME: 'login_username',
  PASSWORD: 'login_password',
  FORGOT_PASSWORD: 'login_forgot_password',
  APP_NAME: 'app_name',
}

export const FORGOT_PASSWORD_KEYS = {
  USERNAME: 'forgot_password_username',
  MOBILE_NO: 'forgot_password_mobile_no',
  DOB: 'forgot_password_dob',
  NEW_PASSWORD: 'forgot_password_new_password',
  CONFIRM_PASSWORD: 'forgot_password_confirm_password',
  CAPCHA: 'forgot_password_capcha',
  OTP: 'forgot_password_otp',
  PASSWORD_CRITERIA: 'forgot_password_password_criteria',
  FORGOT_PASSWORD: 'forgot_password_title',
}

export const VERIFY_CODE_KEYS = {
  TITLE: 'verify_code_title',
  CODE: 'verify_code_text',
  ENTER_CODE: 'verify_code_enter_code',
}

export const RESET_PASSWORD_KEYS = {
  TITLE: 'reset_password_title',
  NEW_PASSWORD: 'reset_password_new_password',
  CONFIRM_PASSWORD: 'reset_password_confirm_password',
}

export const SEND_TO_WALLET_KEYS = {
  TITLE: 'send_to_wallet_title',
  WALLET_NAME: 'send_to_wallet_wallet_name',
  SERVICE_ID: 'send_to_wallet_service_id',
  REGEX_VALUE: 'send_to_wallet_regex_value',
  ERROR_MESSAGE: 'send_to_wallet_error_message',
  NO_WALLET_FOUND: 'send_to_wallet_no_wallet_found',
}

export const CREATE_TERM_DEPOSIT_KEYS = {
  TITLE: 'create_td_title',
  CLOSE_ON_MATURITY: 'create_td_close_on_maturity',
  AUTO_RENEWAL: 'create_td_auto_renewal',
  ROLL_OVER_PRINCIPLE: 'create_td_roll_over_principle',
  ROLL_OVER_PRINCIPLE_INTEREST: 'create_td_roll_over_pronciple_interest',
  DEBIT_ACC_NO: 'create_td_debit_account_no',
  CURRENCY: 'create_td_currency',
  PRODUCT: 'create_td_product',
  TENURE: 'create_td_tenure',
  AMOUNT: 'create_td_amount',
  CONFIRM_TITLE: 'create_td_confirm_title',
  DEPOSIT_TYPE: 'create_td_deposit_type',
  PAYMENT_METHOD: 'create_td_payment_method',
  INTEREST_RATE: 'create_td_interest_rate',
  ACCOUNT_NUMBER: 'create_td_account_no',
  CREDIT_ACCOUNT: 'create_td_credit_account',
  CREDIT_INTEREST_MONTHLY: 'create_td_credit_interest_monthly',
  CREDIT_INTEREST_ON_MATURITY: 'create_td_credit_interest_maturity',
  CREDIT_INTEREST_QUARTERLY: 'create_td_credit_interest_quarterly',
  DAYS: 'create_td_details_days',
  MONTHS: 'create_td_details_months',
  YEARS: 'create_td_details_years',
  TENURE_VALUE: 'create_td_tenure_value',
  PRINCIPLE: 'create_td_principle',
}

export const MENU_NAMES_ICONS_KEYS = {
  STATEMENT: 'menu_names_icons_stmt',
  PROFILE_SETTING: 'menu_names_icons_porfile_setting',
  CHANGE_PASSWORD: 'menu_names_icons_change_password',
  NOTIFICATION: 'menu_names_icons_notification',
  ACCOUNT: 'menu_names_icons_account',
  DOWNLOAD_CENTER: 'menu_names_icons_download_center',
  RECEIPTS: 'menu_names_icons_receipts',
  BANK_STATEMENT: 'menu_names_icons_bank_statement',
  MT103: 'menu_names_icons_mt103',
  SALARY_FILE: 'menu_names_icons_salary_file',
  SUPPORT_CENTER: 'menu_names_icons_support_center',
  FAQ: 'menu_names_icons_faq',
  SUGGESTIONS: 'menu_names_icons_suggestions',
  LOCATE_US: 'support_center_locateUs',
  CONTACT_US: 'menu_names_icons_contact_us',
  ABOUT_US: 'menu_names_icons_about_us',
  OTHER_SERVICES: 'menu_names_icons_other_service',
  CALCULATOR: 'menu_names_icons_calculator',
  TERMS_CONDITIONS: 'menu_names_icons_terms_condition',
  EXCHANGE_RATE: 'menu_names_icons_exchange_rate',
  PORTFOLIO: 'menu_names_icons_portfolio',
  LOANS: 'menu_names_icons_loans',
  APPLY_LOAN: 'menu_names_icons_apply_loan',
  MAKE_LOAN_PAYMENT: 'menu_names_icons_make_loan_payment',
  DEPOSIT: 'menu_names_icons_deposit',
  TERM_DEPOSIT: 'menu_names_icons_term_deposit',
  PAYMENT: 'menu_names_icons_payment',
  SERVICES: 'menu_names_icons_services',
  FORM: 'menu_names_icons_form',
  SCHOOL_PAYMENT: 'menu_names_icons_school_payment',
  OTHER_PAYMENTS: 'menu_names_icons_other_payment',
  BUY_DATA: 'menu_names_icons_buy_data',
  BUY_AIRTIME: 'menu_names_icons_buy_airtime',
  VIEW_BILLER: 'menu_names_icons_view_biller',
  ADD_BILLER: 'menu_names_icons_add_biller',
  PAY_BILLS: 'payments_menu_pay_bill',
  PAY_BILLS_DESC: 'payments_menu_pay_bill_desc',
  TRANSFERS: 'menu_names_icons_transfers',
  BULK_TRANSFER: 'menu_names_icons_bulk_transfer',
  SALARY_UPLOAD: 'menu_names_icons_salary_upload',
  ADD_BENEFICIARY: 'menu_names_icons_add_beneficiary',
  DOWNLOAD_RECEIPT: 'menu_names_icons_download_receipt',
  VIEW_SCHEDULED_PAYMENTS: 'menu_names_icons_view_scheduled_payments',
  VIEW_SCHEDULED_TRANSFERS: 'menu_names_icons_view_scheduled_transfers',
  MAKE_TRANSFER: 'menu_names_icons_make_transfer',
  VIEW_BENEFICIARY: 'menu_names_icons_view_beneficiary',
  INTERNAL: 'menu_names_icons_internal',
  DOMESTIC: 'menu_names_icons_domestic',
  INTERNATIONAL: 'menu_names_icons_international',
  OWN: 'menu_names_icons_own',
  QUICKY_PAY: 'menu_names_icons_quick_pay',
  INSTANT_TRANSFER: 'menu_names_icons_instant_transfer',
  SEND_TO_WALLET: 'menu_names_icons_send_to_wallet',
  QR_PAY: 'menu_names_icons_qr_pay',
  REQUESTS: 'menu_names_icons_requests',
  CHEQUE: 'menu_names_icons_cheque',
  STANDING_INSTRUCTION: 'menu_names_icons_standing_instruction',
  DEBIT_CARD: 'menu_names_icons_debit_card',
  CREATE_SI: 'menu_names_icons_create_si',
  CARD_REQUEST: 'menu_names_icons_card_request',
  CHECK_BOOK_REQUEST: 'menu_names_icons_cheque_book_request',
  STOP_CHEQUE: 'menu_names_icons_stop_cheque',
  CHEQUE_STATUS: 'menu_names_icons_cheque_status',
  LINK_ACCOUNT: 'menu_names_icons_link_account',
  DELINK_ACCOUNT: 'menu_names_icons_delink_account',
  SET_ACCOUNT_NAME: 'menu_names_icons_set_account_name',
  OPEN_ACCOUNT: 'menu_names_icons_open_account',
  DETAILED_STATEMENT: 'menu_names_icons_detailed_stmt',
  VIEW_STATEMENT: 'menu_names_icons_view_stmt',
  APPROVALS: 'menu_names_icons_approvals',
  FUND_TRANSFER: 'menu_names_icons_ft',
  BENEFICIARY: 'menu_names_icons_beneficiry',
  HISTORY: 'menu_names_icons_history',
  DESCRIPTION_HERE: 'menu_names_icons_description',
  CHEQUE_BOOK: 'menu_names_icons_cheque_book',
  PROFILE_DESC: 'menu_names_icons_profile_desc',
  CHANGE_PASSWORD_DESC: 'menu_names_icons_change_password_desc',
  NOTIFY_DESC: 'menu_names_icons_notify_desc',
  VIEW_BILLER_DESC: 'menu_names_icons_view_biller_desc',
  ADD_BILLER_DESC: 'menu_names_icons_add_biller_desc',
  ADD_BENE_DESC: 'menu_names_icons_add_bene_desc',
  HISTORY_DESC: 'menu_names_icons_history_desc',
  CURRENT_MONTH: 'menu_names_icons_current_month',
  LAST_TWO_MONTHS: 'menu_names_icons_last_two_month',
  LAST_THREE_MONTHS: 'menu_names_icons_last_three_month',
  CUSTOM_RANGE: 'menu_names_icons_custom_range',
  CARD_LESS_CASH: 'menu_names_icons_card_less_cash',
  GENERATE_TOKEN: 'menu_names_icons_generate_token',
  DEBIT_CARD: 'menu_names_icons_debit_card',
  REGIONAL: 'menu_names_icons_regional',
  BLOCK_CARD: 'menu_names_icons_block_card',
}

export const LAYOUT_DESC_MENU_ICONS_KEYS = {
  LINK_ACCOUNT: 'layout_desc_link_account',
  DE_LINK_ACCOUNT: 'layout_desc_de_link_account',
  SET_ACCOUNT_NAME: 'layout_desc_set_account_name',
  DOWNLOAD_CENTER: 'layout_desc_download_center',
  APPROVALS: 'layout_desc_approval',
  HISTORY: 'layout_desc_history',
  SALARY_UPLOAD: 'layout_desc_salary_upload',
  NOTIFICATION: 'layout_desc_notification',
  PROFILE_SETTING: 'layout_desc_profile_setting',
  CHANGE_PASSWORD: 'layout_desc_change_password',
  ADDITIONAL_LINK: 'layout_desc_additional_link',
  SUPPORT_CENTER: 'layout_desc_support_center',
  LOANS: 'layout_desc_loans',
  SI: 'layout_desc_si',
  DEPOSITS: 'layout_desc_deposits',
  RECEIPTS: 'layout_desc_receipt',
  SALARY_FILE_STATUS: 'layout_desc_salary_file_status',
  BI_STATEMENT: 'layout_desc_bi_statement',
  MT103: 'layout_desc_mt103',
  LOCATE_US: 'layout_desc_locateUs',
  DEPOSIT: 'layout_desc_deposit',
  FAQ: 'layout_desc_faq',
  SUGGESTIONS: 'layout_desc_suggestion',
  CALCULATOR: 'layout_desc_calculator',
  EXCHANGE_RATE: 'layout_desc_exchange_rate',
  TERMS_CONDITIONS: 'layout_desc_terms_conditions',
  SCHOOL_PAYMENT: 'layout_desc_school_payment',
  ADD_BILLER: 'layout_desc_add_biller',
  VIEW_BILLER: 'layout_desc_view_biller',
  OTHER_PAYMENTS: 'layout_desc_other_payments',
  CONTACT_US: 'layout_desc_contact_us',
  ABOUT_US: 'layout_desc_about_us',
  OTHER_SERVICES: 'layout_desc_other_servies',
  SCHEDULED_PAYMENTS: 'layout_desc_scheduled_payments',
  SCHEDULED_TRANSFERS: 'layout_desc_scheduled_transfers',
  DEBIT_CARD_REQUEST: 'layout_desc_debit_card_request',
}

export const VALIDATION_KEYS = {
  USERNAME_REQUIRED: 'validate_username',
  PASSWORD_REQUIRED: 'validate_password',
  VERIFY_CODE: 'validate_verify_code',
  ALPHA_NUMERIC: 'validate_alpha_numeric',
  USERNAME_MIN_MAX_LENGTH: 'validate_username_min_max_length',
  MOBILE_NO_REQUIRED: 'validate_mobile_no',
  DOB_REQUIRD: 'validate_dob',
  NEW_PASSWORD_REQUIRED: 'validate_new_password',
  NEW_PASSWORD_MIN_LENGTH: 'validate_new_password_min_length',
  NEW_PASSWORD_MAX_LENGTH: 'validate_new_password_max_length',
  PASSWORD_MATCH: 'validate_password_match',
  PASSWORD_MATCH_CRITERIA: 'validate_password_match_criteria',
  CONFIRM_PASSWORD_REQUIRED: 'validate_confirm_password',
  VALIDATE_OTP: 'validate_otp',
  OTP_REQUIRED: 'validate_otp_required',
  CAPCHA: 'validate_capcha',
  CONFIRM_NEW_PASSWORD: 'validate_confirm_new_password',
  TRANSFER_AMOUNT_VALIDATION: 'validate_transfer_amount',
  ACCOUNT_NO_REQUIRED: 'validate_account_no_required',
  FROM_DATE_REQUIRED: 'validate_from_date_required',
  FROM_DATE_FUTURE_DATE: 'validate_from_date_future_date',
  TO_DATE_REQUIRED: 'validate_to_date_required',
  TO_DATE_FUTURE_DATE: 'validate_to_date_future_date',
  TO_DATE_GREATER_FROM_DATE: 'validate_from_date_greater_to_date',
  FORMAT_REQUIRED: 'validate_format_requird',
  REPORTER_NAME_REQUIRED: 'validate_reporter_name_required',
  SELECT_MERCHANT_REQUIRED: 'validate_select_merchant_required',
  IS_REQUIRED: 'validate_is_required',
  SERVICE_NO_MOBILE_NO_IS_REQUIRED: 'validate_service_no_mobile_no_is_required',
  SERVICE_NO_MOBILE_NO_REQUIRED: 'validate_service_no_mobile_no_required',
  SHORT_NAME_REQUIRED: 'validate_short_name_required',
  SHORT_NAME_MIN_LENGTH: 'validation_short_name_min_length',
  SHORT_NAME_MAX_LENGTH: 'validation_short_name_max_length',
  SCHEDULED_PAYMENT_REQUIRED: 'validation_scheduled_payment_required',
  SCHEDULED_DATE_REQUIRED: 'validaton_scheduled_date_required',
  REMARKS_REQUIRED: 'validation_remark_required',
  AMOUNT_REQUIRED: 'validation_amount_required',
  PRODUCT_REQUIRED: 'validation_product_required',
  CUSTOM_REMARK_REQUIRED: 'validation_custom_remark_required',
  DAY_MONTH_YEAR_ONE_FIELD: 'validation_day_month_year_one_field',
  DAY_MONTH_YEAR_EQUAL_MORE: 'validation_day_month_year_equal_more',
  DAY_MONTH_YEAR_MAX_VALUE: 'validation_day_month_year_max_value',
  NARRATIVE: 'verification_narrative',
  GREATER_THAN_ZERO: 'validation_greater_than_zero',
  LOAN_AMOUNT_REQUIRED: 'validation_loan_amount_required',
  LOAN_TENURE_GREATER_EQUAL: 'validation_loan_tenure_greater_equal',
  TENURE_REQUIRED: 'validation_tenure_required',
  LOAN_INTEREST_RATE_GREATER_EQUAL: 'validation_loan_interest_rate_greater_equal',
  INTEREST_RATE_REQUIRED: 'validation_interest_rate_required',
  DEPOSIT_AMOUNT_REQUIRED: 'validation_deposit_amount_required',
  DEPOSIT_TENURE_GREATER_EQUAL: 'validation_deposit_amount_greater_equal',
  DEPOSIT_INTEREST_RATE_GREATER_EQUAL: 'validation_deposit_interest_rate_greater_equal',
  SOURCE_ACCOUNT_NO_REQUIRED: 'validation_source_acc_no_required',
  CURRENCY_REQUIRED: 'validation_currency_required',
  SELL_CURRENCY_REQUIRED: 'validation_sell_currency_required',
  BUY_CURRENCY_REQUIRED: 'validation_buy_currency_required',
  FEEDBACK_MIN_MAX: 'validation_feedback_min_max',
  FEEDBACK_REQUIRED: 'validation_feedback_required',
  FEEDBACK_CATEGORY_REQUIRED: 'validation_feedback_category_required',
  CONFIRM_PASSWORD_NOT_MATCH: 'validation_confirm_password_not_match',
  CURRENT_PASSWORD_REQUIRED: 'validation_current_password_required',
  SHORT_NAME_MIN_MAX: 'validation_short_name_min_max',
  COMMENTS_REQUIRED: 'validation_comments_required',

  PICK_UP_BRANCH_REQUIRED: 'validation_pick_up_branch_required',
  NO_OF_LEAVES_REQUIRED: 'validation_no_of_leaves_required',
  NO_OF_BOOKS_REQUIRED: 'validation_no_of_books_required',
  CHEQUE_NO_REQUIRED: 'validation_cheque_no_required',
  CHEQUE_NO_MIN_MAX: 'validation_cheque_no_min_max',
  EFFECTIVE_DATE_REQUIRED: 'validation_effective_date_required',
  REASON_REQUIRED: 'validation_reason_required',
  REMARKS_MIN_MAX: 'validation_remarks_min_max',
  START_CHEQUE_NO_REQUIRED: 'validation_start_cheque_no_required',
  END_CHEQUE_NO_REQUIRED: 'validation_end_cheque_no_required',
  ACCOUNT_NO_DIGIT: 'validation_account_no_digit',
  CREDIT_ACCOUNT_NO_REQUIRED: 'validation_credit_account_no_required',
  START_DATE_REQUIRED: 'validation_start_date_required',
  START_DATE_GREATER_TODAY: 'validation_start_date_greater_today',
  END_DATE_REQUIRED: 'validation_end_date_required',
  END_DATE_GREATER_TODAY: 'validation_end_date_greater_today',
  END_DATE_GREATER_START_DATE: 'validation_end_date_greater_start_date',
  INVALID_DATE: 'validation_invalid_date',
  REQUEST_TYPE_REQUIRED: 'validation_request_type_required',
  NICK_NAME_REQUIRED: 'validation_nick_name_required',
  NICK_NAME_MIN_MAX: 'validation_nick_name_min_max',
  ACCOUNT_NO_MATCH: 'validation_account_no_match',
  CONFIRM_ACCOUNT_NO_REQUIRED: 'validation_confirm_account_no_required',
  TRANSFER_LIMIT: 'validation_transfer_limit',
  BENEFICIARY_NAME_REQUIRED: 'validation_beneficiar_name_required',
  BENEFICIARY_MIN_MAX: 'validation_beneficiary_min_max',
  ACCOUNT_NO_MIN_MAX: 'validation_account_no_min_max',
  BENE_EMAIL_ID_VALIDATE: 'validation_bene_email_id_validate',
  BENE_EMAIL_ID_REQUIRED: 'validation_bene_email_id_required',
  BENE_MOBILE_NO_MIN_MAX: 'validation_bene_mobile_no_min_max',
  BENE_MOBILE_NO_REQUIRED: 'validation_bene_mobile_no_required',
  BENEFICIARY_BANK_REQUIRED: 'validation_beneficiary_bank_required',
  BRANCH_NAME_REQUIRED: 'validation_branch_name_required',

  NICK_NAME_MIN_MAX_LEN: 'validation_nick_name_min_max_len',
  BANK_ADDRESS_REQUIRED: 'validation_bank_address_required',
  BENEFICIARY_COUNTRY_REQUIRED: 'validation_beneficiary_country_required',
  BANK_COUNTRY_REQUIRED: 'validation_bank_country_required',
  ADDRESS_REQUIRED: 'validation_address_required',
  IFSC_CODE_REQUIRED: 'validation_ifsc_code_required',
  IFSC_CODE_MIN_MAX: 'validation_ifsc_min_max',
  SWIFT_CODE_REQUIRED: 'validation_swift_code_required',
  SWIFT_CODE_MIN_MAX: 'validation_swift_code_min_max',
  TRANSFER_AMOUNT_REQUIRED: 'validation_transfer_amount_required',
  FX_REF_NO_REQUIRED: 'validation_fx_ref_no_required',
  BENE_ALERT_REQUIRED: 'validation_bene_alert_required',
  SENDER_TO_RECEIVER_INFO: 'validation_sender_to_receiver_info',
  REQUIRED: 'validation_required',
  ACCOUNT_TYPE_REQUIRED: 'validation_account_type_required',
  BANK_NAME_REQUIRED: 'validation_bank_name_required',
  CONFIRM_ACCOUNT_NO_MATCH: 'validation_confirm_account_no_match',
  BENEFICIARY_ACCOUNT_NO_REQUIRED: 'validation_beneficiary_account_no_required',
  TRANSFER_TYPE_REQUIRED: 'validation_transfer_type_required',
  TXN_CURRENCY_REQUIRED: 'validation_txn_currency_required',
  INTERST_CREDIT: 'validation_interest_credit',
  TENURE_VALUE_REQUIRED: 'validation_tenure_value_required',
  DEBIT_ACCOUNT_NO_REQUIRED: 'validation_debit_acc_no_required',
  PROCESS_NAME_REQUIRED: 'validation_process_name_required',
  TOTAL_AMOUNT_REQUIRED: 'validation_total_amount_required',
  SERVICE_NO: 'validation_service_no',
  STUDENT_CLASS: 'validation_student_class_required',
  AMOUNT: 'validation_amount',
  REMARK: 'validation_remarks',
  PRODUCT: 'validation_product',
  BILL_NO: 'bill_no_required',
  SCHOOL_BENE_BANK_TYPE: 'validation_message_school_bene_bank_type',
  SCHOOL_BENE_BANK: 'validation_message_school_bene_bank',
  CLASS_NAME: 'validation_message_class_name',
  SCHOOL_NAME: 'validation_message_school_name',
  STUDENT_NAME: 'validation_message_student_name',
  SCHOOL_TERM: 'validation_message_school_term',
  FEES_PURPOSE: 'validation_message_fees_purpose',
  SCHOOL_YEAR: 'validation_message_school_year',
  CHEQUE_NUMBER_REQUIRED: 'validation_cheque_number_required',
  CHEQUE_NUMBER_LENGTH: 'validation_cheque_number_length',
  RECEIVER_MOBILE_NO: 'validation_receiver_mobile_no_required',
  VALID_MOBILE_NO: 'validation_validate_mobile_no',
  REMARK_LENGTH: 'validation_remark_length',
  VALIDITY_REQUIRED: 'validation_validity_required',
  ROUTING_NUMBER_REQUIRED: 'validation_routing_number_required',
  ROUTING_NUMBER_MIN_MAX: 'validation_number_min_max',
  BENEFICIARY_NAME_VALID: 'validaion_beneficiary_name_valid',
  VALID_NICK_NAME: 'validation_nick_name',
  CARD_PRODUCTS_REQUIRED: 'validation_card_products_required',
  MOBILE_NUMBER_REQUIRED: 'validation_mobile_number_required',
  NO_IS_REQUIRED: 'validation_no_is_required',
  TRANSCTIONCURRENY: 'validation_transction_currency_required',
  CARD_NUMBER: 'validation_card_number',
}

export const CHEQUE_STATUS_KEYS = {
  TITLE: 'cheque_status_title',
  CHEQUE: 'cheque_status_cheque',
  CHECK_STATUS: 'cheque_status_chequestatus',
  SUBTITLE: 'cheque_status_subtitle',
  ACCOUNT_NUMBER: 'cheque_status_accountNumber',
  CHEQUE_NUMBER: 'cheque_status_chequeNumber',
  SUBMIT: 'cheque_status_submit',
  CONFIRM: 'cheque_status_confirm',
  STATUS: 'cheque_status_status',
  NO_ACCESS: 'cheque_status_no_access',
  NO_ACCOUNTS: 'cheque_status_No_accounts',
  DATE_ON_CHECK: 'cheque_status_dateoncheck',
  BENEFICIARY_ACCOUNT: 'cheque_status_beneAccountno',
  AMOUNT: 'cheque_status_amount',
  NOT_UTILIZED: 'cheque_status_not_utilized',
  UTILIZED: 'cheque_status_utilized',
  STOPPED: 'cheque_status_stopped',
  REJECT: 'cheque_status_reject',
}

export const CARD_REQUEST_KEYS = {
  TITLE: 'card_request_title',
  ACCOUNT_NO: 'card_request_account_no',
  CARD_PRODUCTS: 'card_request_card_products',
  ADDRESS: 'card_request_address',
  BRANCH: 'card_request_branch',
  DELIVERY_MODE: 'card_request_delivery_mode',
  BRANCH_NAME: 'card_request_branch_name',
  REQUEST_TYPE: 'card_request_request_type',
  CONFIEM_TITLE: 'card_request_confirm_title',
  SUBTITLE: 'card_request_subtitle',
}
